import {ROUTE_APPROVE_SALON_MTP, ROUTE_SALON_MTP_APPROVAL} from '@app/navigations/RoutePathConstant';
import {authLoader} from '../../loader';
import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';

const SalonMTPApproval = lazy(() =>
  import('../../../screens/SalonMTPApprovalScreen')
    .then(module => ({default: module.SalonMTPApprovalScreen})));

const ApproveSalonMTP = lazy(() =>
  import('../../../screens/SalonMTPApprovalScreen')
    .then(module => ({default: module.ApproveMTPScreen})));

const SalonMTPApprovalNavigation = [
  {
    path: ROUTE_SALON_MTP_APPROVAL,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <SalonMTPApproval />
      </Suspense>
    ),
  },
  {
    path: ROUTE_APPROVE_SALON_MTP,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <ApproveSalonMTP />
      </Suspense>
    ),
  },
];

export default SalonMTPApprovalNavigation;
